<template>
  <div>
    <h3 class="text-h6 mb-4">Configuración de Campos por Sección</h3>
    
    <v-alert type="info" text dense class="mb-4">
      Configure qué campos mostrar en cada sección del remito.
    </v-alert>

    <v-expansion-panels v-model="panelAbierto" multiple>
      <!-- Sección Cliente -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon left>mdi-account</v-icon>
            <strong>Cliente</strong>
            <v-chip small class="ml-2">{{ contarVisibles('cliente') }} campos</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Visible</th>
                  <th>Campo</th>
                  <th>Etiqueta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campo in camposInternosCliente" :key="campo.campo">
                  <td>
                    <v-checkbox
                      v-model="campo.visible"
                      hide-details
                      @change="emitirCambios"
                    ></v-checkbox>
                  </td>
                  <td>{{ getNombreCampo(campo.campo) }}</td>
                  <td>
                    <v-text-field
                      v-model="campo.label"
                      dense
                      hide-details
                      :disabled="!campo.visible"
                      @input="emitirCambios"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Sección Entrega -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon left>mdi-truck-delivery</v-icon>
            <strong>Entrega</strong>
            <v-chip small class="ml-2">{{ contarVisibles('entrega') }} campos</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Visible</th>
                  <th>Campo</th>
                  <th>Etiqueta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campo in camposInternosEntrega" :key="campo.campo">
                  <td>
                    <v-checkbox
                      v-model="campo.visible"
                      hide-details
                      @change="emitirCambios"
                    ></v-checkbox>
                  </td>
                  <td>{{ getNombreCampo(campo.campo) }}</td>
                  <td>
                    <v-text-field
                      v-model="campo.label"
                      dense
                      hide-details
                      :disabled="!campo.visible"
                      @input="emitirCambios"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Sección Solicitud -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon left>mdi-file-document</v-icon>
            <strong>Solicitud</strong>
            <v-chip small class="ml-2">{{ contarVisibles('solicitud') }} campos</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Visible</th>
                  <th>Campo</th>
                  <th>Etiqueta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campo in camposInternosSolicitud" :key="campo.campo">
                  <td>
                    <v-checkbox
                      v-model="campo.visible"
                      hide-details
                      @change="emitirCambios"
                    ></v-checkbox>
                  </td>
                  <td>{{ getNombreCampo(campo.campo) }}</td>
                  <td>
                    <v-text-field
                      v-model="campo.label"
                      dense
                      hide-details
                      :disabled="!campo.visible"
                      @input="emitirCambios"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Sección Transporte -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon left>mdi-truck</v-icon>
            <strong>Transporte</strong>
            <v-chip small class="ml-2">{{ contarVisibles('transporte') }} campos</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Visible</th>
                  <th>Campo</th>
                  <th>Etiqueta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campo in camposInternosTransporte" :key="campo.campo">
                  <td>
                    <v-checkbox
                      v-model="campo.visible"
                      hide-details
                      @change="emitirCambios"
                    ></v-checkbox>
                  </td>
                  <td>{{ getNombreCampo(campo.campo) }}</td>
                  <td>
                    <v-text-field
                      v-model="campo.label"
                      dense
                      hide-details
                      :disabled="!campo.visible"
                      @input="emitirCambios"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'CamposEditor',
  
  props: {
    camposConfig: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      panelAbierto: [0],
      camposInternosCliente: [],
      camposInternosEntrega: [],
      camposInternosSolicitud: [],
      camposInternosTransporte: [],
      nombresCampos: {
        // Cliente
        razonSocial: 'Razón Social',
        direccion: 'Dirección',
        localidad: 'Localidad',
        codigoPostal: 'Código Postal',
        cuit: 'CUIT',
        // Entrega
        domicilio: 'Domicilio',
        provincia: 'Provincia',
        // Solicitud
        numero: 'Número',
        tipo: 'Tipo',
        pedidos: 'Pedidos',
        bultos: 'Bultos',
        kilos: 'Kilos',
        // Transporte
        nombre: 'Nombre',
        cuit: 'CUIT'
      }
    }
  },

  watch: {
    camposConfig: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.camposInternosCliente = JSON.parse(JSON.stringify(newVal.cliente || []))
          this.camposInternosEntrega = JSON.parse(JSON.stringify(newVal.entrega || []))
          this.camposInternosSolicitud = JSON.parse(JSON.stringify(newVal.solicitud || []))
          this.camposInternosTransporte = JSON.parse(JSON.stringify(newVal.transporte || []))
        }
      }
    }
  },

  methods: {
    getNombreCampo(campo) {
      return this.nombresCampos[campo] || campo
    },

    contarVisibles(seccion) {
      const campos = this[`camposInternos${this.capitalize(seccion)}`]
      if (!campos) return 0
      return campos.filter(c => c.visible).length
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    emitirCambios() {
      this.$emit('update', {
        cliente: this.camposInternosCliente,
        entrega: this.camposInternosEntrega,
        solicitud: this.camposInternosSolicitud,
        transporte: this.camposInternosTransporte
      })
    }
  }
}
</script>
